import ProductoCodificado from "./ProductoCodificado";

export default ProductoCodificado;
